import Client from '../axios-client';

const resource = '/application/applications';

export default {
  addInvoiceToApplication(applicationId, payload) {
    return Client.post(
      `${resource}/${applicationId}/medical-expense-reimbursement/invoice/invoices`,
      payload,
      {
        headers: { 'Content-Type': 'multipart/form-data' }
      }
    );
  },
  removeInvoiceFromApplication(applicationId, invoiceId, version) {
    return Client.delete(`${resource}/${applicationId}/medical-expense-reimbursement/invoice/invoices/${invoiceId}?version=${version}`);
  },
  getInvoiceFile(applicationId, invoiceId) {
    return Client.get(`${resource}/${applicationId}/medical-expense-reimbursement/invoice/invoices/${invoiceId}/download?base64=true`)
  },
  approveInvoiceInApplication(applicationId, invoiceId, version) {
    return Client.put(`${resource}/${applicationId}/medical-expense-reimbursement/invoice/invoices/${invoiceId}/approve?version=${version}`);
  },
  rejectInvoiceFromApplication(applicationId, invoiceId, payload) {
    return Client.put(`${resource}/${applicationId}/medical-expense-reimbursement/invoice/invoices/${invoiceId}/reject`, payload);
  },
  addRoadCardToApplication(applicationId, payload) {
    return Client.post(
      `${resource}/${applicationId}/medical-expense-reimbursement/road-card/road-cards`,
      payload,
      {
        headers: { 'Content-Type': 'multipart/form-data' }
      }
    );
  },
  removeRoadCardFromApplication(applicationId, roadCardId, version) {
    return Client.delete(`${resource}/${applicationId}/medical-expense-reimbursement/road-card/road-cards/${roadCardId}?version=${version}`);
  },
  getRoadCardFile(applicationId, roadCardId) {
    return Client.get(`${resource}/${applicationId}/medical-expense-reimbursement/road-card/road-cards/${roadCardId}/download?base64=true`)
  },
  approveRoadCardInApplication(applicationId, roadCardId, version) {
    return Client.put(`${resource}/${applicationId}/medical-expense-reimbursement/road-card/road-cards/${roadCardId}/approve?version=${version}`);
  },
  rejectRoadCardFromApplication(applicationId, roadCardId, payload) {
    return Client.put(`${resource}/${applicationId}/medical-expense-reimbursement/road-card/road-cards/${roadCardId}/reject`, payload);
  },
}
